import { createFileRoute } from "@tanstack/react-router";
import { DesignSystemHome } from "@/pages/design-system/DesignSystemHome";

export const Route = createFileRoute("/demo/design-system/")({
  component: DesignSystemHome,
});
